import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';
import withWebsiteContent from '../../../common/withWebsiteContent';
import { sectionScrollMarginSx } from '../../../common/hooks/useScrollSpyHash';

/**
 * Pure Location component — all content supplied via props.
 *
 * Expected website-component defaultProps shape (location.json):
 * { "title": "...", "description": "...", "mapEmbedUrl": "..." }
 */
export const LocationPure = ({ id, title = '', description = '', mapEmbedUrl = '', images = [] }) => {
  if (!title && !description && !mapEmbedUrl) return null;

  return (
    <Box id={id} component="section" sx={sectionScrollMarginSx}>
      <Container sx={{ py: 4 }}>
      {title && (
        <Typography
          variant="h4"
          component="h2"
          sx={{ textAlign: 'center', mb: description || mapEmbedUrl ? 4 : 1, fontWeight: 600 }}
        >
          {title}
        </Typography>
      )}
      {(description || mapEmbedUrl) && (
        <Paper sx={{ p: 4 }}>
          {description && (
            <Typography variant="body1" paragraph>
              {description}
            </Typography>
          )}
          {mapEmbedUrl && (
            <Box
              sx={{
                position: 'relative',
                width: '100%',
                paddingTop: '56.25%',
                mt: description ? 2 : 0,
                overflow: 'hidden',
                borderRadius: 1,
              }}
            >
              <Box
                component="iframe"
                src={mapEmbedUrl}
                title="Location map"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  border: 0,
                }}
              />
            </Box>
          )}
        </Paper>
      )}
      </Container>
    </Box>
  );
};

const Location = withWebsiteContent(LocationPure);
Location.displayName = 'Location';

export default Location;
